import { Fragment, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Menu, Transition } from "@headlessui/react";
import { axiosPrivate } from "../../api/axios";
import { CustomAxiosRequestConfig } from "../login/EnterOtp";
import { useLocation, useParams } from "react-router";
import { useUserContext } from "../../context/UserContext";
import { useStoreContext } from "../../context/StoreContext";
import { useNavigate } from "react-router-dom";
import { ReactComponent as AdminDashboard } from "../../iconColor/user-settings.svg";
import { ReactComponent as Vam30hand } from "../../iconColor/vam30-hand-M.svg";
import animationData from "../../../src/jsons/ddddot.json";
import Lottie from "react-lottie";
import { IconUserCircle } from "@tabler/icons-react";
import {
  CREDITOR_CONTEXT,
  STORE_HOME_CONTEXT,
  USER_HOME_CONTEXT,
} from "../../api/apiClient";
import { useCreditorContext } from "../../context/CreditorContext";
import LogoComponent from "../common/LogoComponent";
import Loading from "../common/Loading";
import Swal from "sweetalert2";

import ButtonComponent from "../elements/ButtonComponent";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export default function DropDownElement({ logOut }: any) {
  const navigate = useNavigate();
  const access_token = localStorage.getItem("access_token");
  const [jwtDecodeResponse, setJwtDecodeResponse] = useState<any>();
  const [creditorImage, setCreditorImage] = useState(null);
  const [filteredPanelsStore, setFilteredPanelsStore] = useState<any>();
  const [storeImage, setStoreImage] = useState(null);
  const [dropDownIsLoading, setdropDownIsLoading] = useState<any>(false);

  const location = useLocation();
  const path = location.pathname;

  const isDashboardPath = path.includes("/dashboard");
  const isCreditorPath = path.includes("/creditor-dashboard");
  const isAdminPath = path.includes("/admin-dashboard");
  const isUserPath = path.includes("/user-panel");

  const { userData, setUserData } = useUserContext();

  const { storeData, setStoreData } = useStoreContext();
  const { creditor, setCreditor } = useCreditorContext();

  const [isHoveredStoreName, setIsHoveredStoreName] = useState(false);
  const [isHoveredCreditor, setIsHoveredCreditor] = useState(false);
  const [loadingHomeContext, setLoadingHomeContext] = useState(false);

  const truncateText = (text: string, length: any, indicator = "...") => {
    if (!text || text.length <= length) return text;
    return text.substring(0, length) + indicator;
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  const userContextAPI = async () => {
    setLoadingHomeContext(true);
    try {
      const contextResponse = await axiosPrivate.get(USER_HOME_CONTEXT, {
        headers: {
          accept: "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
        },
        withCredentials: true,
        globalErrorHandler: false,
      } as CustomAxiosRequestConfig);
      if (contextResponse?.status >= 200 && contextResponse.status < 300) {
        setLoadingHomeContext(false);
        localStorage.setItem(
          "view_only",
          contextResponse.data.data.phone_number === "09395893600"
            ? "true"
            : "false"
        );
        localStorage.setItem(
          "user_state",
          contextResponse?.data?.data?.user_state
        );
        setUserData(contextResponse?.data?.data);
      }
      setJwtDecodeResponse(contextResponse?.data?.data?.panels?.panels);

      contextResponse?.data?.data?.panels?.panels?.filter(
        (panel: any) => panel.type === "creditor"
      )?.length === 1 &&
        localStorage.setItem(
          "selected_creditor_uid",
          contextResponse?.data?.data?.panels?.panels?.filter(
            (panel: any) => panel.type === "creditor"
          )?.[0]?.uid
        );

      setFilteredPanelsStore(
        contextResponse?.data?.data?.panels?.panels?.filter(
          (panel: any) => panel.type === "store"
        )
      );
    } catch (error) {
      setLoadingHomeContext(false);
      console.error("Error fetching contextResponse", error);
    } finally {
      setLoadingHomeContext(false);
    }
  };

  useEffect(() => {
    userContextAPI();
  }, []);

  const storeUserContextAPI = async (panels: any) => {
    setdropDownIsLoading(true);
    localStorage.setItem("selected_store_uid", panels?.uid);
    try {
      const storeUserContextAPIResponse = await axiosPrivate.get(
        STORE_HOME_CONTEXT(panels?.uid),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
          },
          withCredentials: true,
          globalErrorHandler: false,
        } as CustomAxiosRequestConfig
      );
      if (
        storeUserContextAPIResponse.status >= 200 &&
        storeUserContextAPIResponse.status < 300
      ) {
        setStoreData(storeUserContextAPIResponse?.data?.data);

        setStoreImage(storeUserContextAPIResponse?.data?.data?.url);
        setdropDownIsLoading(false);
      }
    } catch (error) {
      setdropDownIsLoading(false);
      console.error("Error fetching contextResponse", error);
    }
  };

  const creditorUserContextAPI = async (panels: any) => {
    setdropDownIsLoading(true);

    try {
      const creditorContextAPIResponse = await axiosPrivate.get(
        CREDITOR_CONTEXT(panels?.uid),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
          },
          withCredentials: true,
        }
      );

      if (
        creditorContextAPIResponse.status >= 200 &&
        creditorContextAPIResponse.status < 300
      ) {
        setCreditor(creditorContextAPIResponse?.data?.data);
        setCreditorImage(creditorContextAPIResponse?.data?.data?.url);
        setdropDownIsLoading(false);
      }
    } catch (error) {
      setdropDownIsLoading(false);

      console.error("Error fetching contextResponse", error);
    }
  };

  const handleDirectToStoreAuth = () => {
    if (filteredPanelsStore?.length > 0) {
      Swal.fire({
        title: "شما فروشگاه ثبت شده دارید",
        html: '<div><div class="mb-4">یک مورد را انتخاب نمایید: </div><div id="custom-buttons-container"> </div></div>',
        cancelButtonText: `
        لغو
      `,
        icon: "info",
        showCancelButton: true,
        showConfirmButton: false,
        didOpen: () => {
          const container = document.getElementById("custom-buttons-container");
          if (container) {
            ReactDOM.render(
              <div className="flex flex-col gap-2">
                <div className="flex flex-wrap item-center justify-between">
                  {filteredPanelsStore.map((panel: any) => (
                    <ButtonComponent
                      key={panel.uid}
                      onClick={() => {
                        localStorage.setItem("selected_store_uid", panel.uid);
                        Swal.close();
                        navigate("/fa/seller-auth");
                      }}
                      className="mx-2 my-2 w-[100%]"
                    >
                      فروشگاه {panel.name}
                    </ButtonComponent>
                  ))}
                </div>
                <ButtonComponent
                  variant="outlined"
                  bgColor="bg-red-600"
                  borderColor="border-red-600"
                  textColor="text-red-600"
                  onClick={() => {
                    localStorage.removeItem("selected_store_uid");
                    Swal.close();
                    navigate("/fa/seller-auth");
                  }}
                >
                  ساخت فروشگاه جدید
                </ButtonComponent>
              </div>,
              container
            );
          }
        },
      });
    } else {
      navigate("/fa/seller-auth");
    }
  };

  const params = useParams();

  return (
    <Menu
      dir="ltr"
      as="div"
      className="bg-primary-50 relative inline-block text-left rounded-md z-[5000] "
    >
      <div className="">
        <Menu.Button className="flex items-center justify-between min-w-44 gap-x-1.5 rounded-md px-3 py-1 shadow-sm ring-inset ring-gray-300">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="#123DA1"
          >
            <path d="M10.0144 13.3327C9.70502 13.3326 9.40833 13.2158 9.18958 13.0078L4.52292 8.57243C4.41149 8.47014 4.32261 8.34779 4.26147 8.21251C4.20032 8.07722 4.16814 7.93172 4.16679 7.78449C4.16545 7.63726 4.19496 7.49125 4.25363 7.35498C4.31229 7.2187 4.39892 7.0949 4.50846 6.99079C4.618 6.88668 4.74826 6.80434 4.89164 6.74859C5.03502 6.69283 5.18864 6.66478 5.34355 6.66606C5.49846 6.66734 5.65155 6.69793 5.79389 6.75604C5.93623 6.81415 6.06496 6.89863 6.17258 7.00453L10.0144 10.6559L13.8562 7.00453C14.0763 6.80255 14.371 6.69078 14.6769 6.69331C14.9828 6.69584 15.2754 6.81245 15.4917 7.01804C15.708 7.22363 15.8307 7.50174 15.8334 7.79247C15.836 8.08321 15.7184 8.3633 15.5059 8.57243L10.8392 13.0078C10.6205 13.2158 10.3238 13.3326 10.0144 13.3327Z" />
          </svg>
          <div className="flex flex-col items-end justify-end">
            <div className="mb-0 pb-0 text-gray-500 ">
              {isUserPath
                ? ""
                : userData?.panels?.admin && isAdminPath
                ? "وامسی"
                : isDashboardPath && storeData
                ? "فروشگاه"
                : isCreditorPath
                ? "اعتبار دهنده"
                : ""}
            </div>
            <div className="mb-0 pb-0 text-gray-900 text-center whitespace-nowrap">
              {isUserPath
                ? userData?.username
                : userData?.panels?.admin && isAdminPath
                ? userData?.username
                : isDashboardPath && storeData
                ? storeData?.name
                : isCreditorPath
                ? creditor?.name
                : userData?.username || (
                    <Lottie options={defaultOptions} height={20} />
                  )}
            </div>
          </div>

          <div className="h-[32px] w-[32px] flex items-center justify-center ml-4">
            {access_token ? (
              userData?.panels?.admin && isAdminPath ? (
                <Vam30hand />
              ) : isDashboardPath && storeData && storeImage ? (
                <LogoComponent
                  imageUID={storeImage}
                  access_token={access_token}
                />
              ) : isCreditorPath && creditorImage ? (
                <LogoComponent
                  imageUID={creditorImage}
                  access_token={access_token}
                />
              ) : (
                <IconUserCircle />
              )
            ) : (
              <IconUserCircle />
            )}
          </div>
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          dir="rtl"
          className="absolute z-[9999999999999] left-0  mt-2 w-56 origin-top-right rounded-md bg-white drop-shadow-md border ring-black ring-opacity-5 focus:outline-none"
        >
          <div
            className={`${
              isUserPath ? "bg-primary-100" : ""
            } py-1 m-1 rounded-lg hover:bg-primary-100 cursor-pointer`}
            onClick={() => navigate("/fa/user-panel")}
            onContextMenu={(e) => {
              e.preventDefault();
              window.open("/fa/user-panel", "_blank");
            }}
          >
            <Menu.Item>
              {({ active }) => (
                <div
                  className={`${
                    isUserPath
                      ? "text-primary-800 font-bold rounded-lg"
                      : "text-gray-800"
                  } py-1 mr-4 hover:text-primary-700   flex items-center justify-start gap-2`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="currentColor"
                  >
                    <path d="M16.2892 8.46966L14.7874 6.96965L9.5309 1.71959C9.39008 1.57899 9.19912 1.5 9 1.5C8.80088 1.5 8.60992 1.57899 8.4691 1.71959L3.21264 6.96965L1.71079 8.46966C1.57401 8.61112 1.49832 8.80057 1.50003 8.99722C1.50174 9.19387 1.58071 9.38198 1.71994 9.52104C1.85917 9.6601 2.04751 9.73897 2.2444 9.74068C2.44129 9.74239 2.63097 9.66679 2.7726 9.53018L2.99262 9.31042V15C2.99262 15.3978 3.15085 15.7793 3.4325 16.0607C3.71415 16.342 4.09615 16.5 4.49446 16.5H6.74723C6.94639 16.5 7.13739 16.421 7.27821 16.2803C7.41904 16.1397 7.49815 15.9489 7.49815 15.75V12.75C7.49815 12.551 7.57727 12.3603 7.71809 12.2196C7.85892 12.079 8.04992 12 8.24908 12H9.75092C9.95008 12 10.1411 12.079 10.2819 12.2196C10.4227 12.3603 10.5018 12.551 10.5018 12.75V15.75C10.5018 15.9489 10.581 16.1397 10.7218 16.2803C10.8626 16.421 11.0536 16.5 11.2528 16.5H13.5055C13.9039 16.5 14.2858 16.342 14.5675 16.0607C14.8492 15.7793 15.0074 15.3978 15.0074 15V9.31042L15.2274 9.53018C15.369 9.66679 15.5587 9.74239 15.7556 9.74068C15.9525 9.73897 16.1408 9.6601 16.2801 9.52104C16.4193 9.38198 16.4983 9.19387 16.5 8.99722C16.5017 8.80057 16.426 8.61112 16.2892 8.46966Z" />
                  </svg>

                  <p
                    className={classNames(
                      `block text-Body-OneLine/14/Regular `
                    )}
                  >
                    پنل متقاضی
                  </p>
                </div>
              )}
            </Menu.Item>
          </div>

          <div className="border-b ">
            {loadingHomeContext ? (
              <>
                <Loading width={50} height={50} />
              </>
            ) : (
              <>
                {jwtDecodeResponse
                  ?.slice()
                  .reverse()
                  .map((panels: any, index: any) =>
                    dropDownIsLoading ? (
                      <Lottie
                        options={defaultOptions}
                        height={28}
                        key={index}
                      />
                    ) : panels?.type === "creditor" ? (
                      <div
                        key={index}
                        className={`py-1 m-1 rounded-lg hover:bg-primary-100 cursor-pointer `}
                      >
                        {loadingHomeContext ? (
                          <>
                            <Loading />
                          </>
                        ) : (
                          <Menu.Item>
                            {() => (
                              <div
                                onClick={async () => {
                                  await creditorUserContextAPI(panels);
                                  storeUserContextAPI(panels);
                                  navigate(
                                    `/fa/creditor-dashboard/${panels.uid}`
                                  );
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  window.open(
                                    `/fa/creditor-dashboard/${panels.uid}`,
                                    "_blank"
                                  );
                                }}
                                className={`py-1 hover:text-primary-700 flex items-center justify-start gap-2 ${
                                  isCreditorPath &&
                                  params?.creditor_uid === panels.uid
                                    ? "bg-primary-100 rounded-lg text-primary-800 font-bold"
                                    : ""
                                }  `}
                              >
                                <div
                                  className="flex items-center gap-3 mr-4"
                                  onMouseEnter={() =>
                                    setIsHoveredCreditor(true)
                                  }
                                  onMouseLeave={() =>
                                    setIsHoveredCreditor(false)
                                  }
                                >
                                  {panels.icon ? (
                                    panels.icon
                                  ) : (
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="currentColor"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M7.99 2.91279L6.016 0.522819C5.95298 0.447103 5.87485 0.384313 5.78623 0.338153C5.69761 0.291993 5.60028 0.263399 5.5 0.254056C5.29866 0.236573 5.09832 0.296574 4.94275 0.420949L1.87825 2.91279H7.99Z" />
                                      <path d="M6.25 9.41511V8.69263C6.25 7.92618 6.56607 7.19111 7.12868 6.64915C7.69129 6.10718 8.45435 5.80271 9.25 5.80271H13V5.08023C13 4.88861 12.921 4.70485 12.7803 4.56936C12.6397 4.43387 12.4489 4.35775 12.25 4.35775H1C0.801088 4.35775 0.610322 4.43387 0.46967 4.56936C0.329018 4.70485 0.25 4.88861 0.25 5.08023V13.0275C0.25 13.2191 0.329018 13.4029 0.46967 13.5384C0.610322 13.6739 0.801088 13.75 1 13.75H12.25C12.4489 13.75 12.6397 13.6739 12.7803 13.5384C12.921 13.4029 13 13.2191 13 13.0275V12.305H9.25C8.45435 12.305 7.69129 12.0006 7.12868 11.4586C6.56607 10.9166 6.25 10.1816 6.25 9.41511Z" />
                                      <path d="M13 7.24767H9.25C8.85218 7.24767 8.47064 7.39991 8.18934 7.67089C7.90804 7.94187 7.75 8.30941 7.75 8.69263V9.41511C7.75 9.79834 7.90804 10.1659 8.18934 10.4369C8.47064 10.7078 8.85218 10.8601 9.25 10.8601H13C13.1989 10.8601 13.3897 10.784 13.5303 10.6485C13.671 10.513 13.75 10.3292 13.75 10.1376V7.97015C13.75 7.77854 13.671 7.59477 13.5303 7.45928C13.3897 7.32379 13.1989 7.24767 13 7.24767ZM10.375 9.77635C10.2267 9.77635 10.0817 9.73398 9.95832 9.65459C9.83499 9.57521 9.73886 9.46237 9.68209 9.33036C9.62532 9.19834 9.61047 9.05307 9.63941 8.91292C9.66835 8.77278 9.73978 8.64404 9.84467 8.543C9.94956 8.44196 10.0832 8.37315 10.2287 8.34527C10.3742 8.3174 10.525 8.33171 10.662 8.38639C10.7991 8.44107 10.9162 8.53367 10.9986 8.65248C11.081 8.7713 11.125 8.91098 11.125 9.05387C11.125 9.24549 11.046 9.42925 10.9053 9.56474C10.7647 9.70024 10.5739 9.77635 10.375 9.77635Z" />
                                      <path d="M9.07225 2.91278H10.99L9.016 0.522818C8.89208 0.372784 8.71136 0.276317 8.5136 0.254638C8.31585 0.23296 8.11725 0.287845 7.9615 0.407221C7.80575 0.526596 7.70561 0.700683 7.68311 0.891184C7.6606 1.08168 7.71758 1.273 7.8415 1.42303L9.07225 2.91278Z" />
                                    </svg>
                                  )}
                                  {isHoveredCreditor ? (
                                    <p
                                      className={classNames(
                                        " text-Body-OneLine/14/Regular fulltext"
                                      )}
                                      title={panels.name}
                                    >
                                      اعتباردهنده {panels.name}
                                    </p>
                                  ) : (
                                    <p
                                      className={classNames(
                                        " text-Body-OneLine/14/Regular truncatetext"
                                      )}
                                      title={panels.name}
                                    >
                                      اعتباردهنده{" "}
                                      {truncateText(panels.name, 11)}
                                    </p>
                                  )}
                                </div>
                              </div>
                            )}
                          </Menu.Item>
                        )}
                      </div>
                    ) : (
                      panels?.type === "store" && (
                        <div
                          key={index}
                          className={`py-1 m-1 rounded-lg hover:bg-primary-100 cursor-pointer `}
                        >
                          <Menu.Item>
                            {() => (
                              <div
                                onClick={() => {
                                  navigate("/fa/dashboard");
                                  storeUserContextAPI(panels);

                                  localStorage.setItem(
                                    "selected_store_uid",
                                    panels.uid
                                  );
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  window.open("/fa/dashboard", "_blank");
                                }}
                                className={`py-1 hover:text-primary-700 flex items-center justify-start gap-2 ${
                                  isDashboardPath &&
                                  localStorage.getItem("selected_store_uid") ===
                                    panels.uid
                                    ? "bg-primary-100 rounded-lg text-primary-800 font-bold"
                                    : ""
                                }`}
                              >
                                <div
                                  className="mr-4 flex items-center gap-3 "
                                  onMouseEnter={() =>
                                    setIsHoveredStoreName(true)
                                  }
                                  onMouseLeave={() =>
                                    setIsHoveredStoreName(false)
                                  }
                                >
                                  {panels.icon ? (
                                    panels.icon
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="currentColor"
                                    >
                                      <path d="M15.75 6.33553C15.75 5.42392 14.6524 3.25895 14.3163 2.61734C14.258 2.50603 14.1723 2.41323 14.0683 2.34862C13.9643 2.28401 13.8458 2.24995 13.725 2.25H4.275C4.15541 2.24995 4.03796 2.28334 3.93466 2.34676C3.83135 2.41018 3.74591 2.50135 3.68708 2.61095C3.35025 3.23976 2.25 5.36566 2.25 6.33553C2.25029 6.64581 2.31025 6.95283 2.42625 7.23808C2.54226 7.52333 2.71191 7.78091 2.925 7.99532V15.0395C2.925 15.2279 2.99612 15.4086 3.1227 15.5419C3.24929 15.6751 3.42098 15.75 3.6 15.75H4.95C5.12902 15.75 5.30071 15.6751 5.4273 15.5419C5.55388 15.4086 5.625 15.2279 5.625 15.0395V10.7763H8.325V15.0395C8.325 15.2279 8.39612 15.4086 8.5227 15.5419C8.64929 15.6751 8.82098 15.75 9 15.75H14.4C14.579 15.75 14.7507 15.6751 14.8773 15.5419C15.0039 15.4086 15.075 15.2279 15.075 15.0395V7.96547C15.2845 7.75442 15.452 7.50163 15.5679 7.22182C15.6838 6.942 15.7457 6.64074 15.75 6.33553ZM4.67393 3.67105H13.32C13.7861 4.5073 14.149 5.40268 14.4 6.33553C14.3861 6.5663 14.2928 6.78383 14.1375 6.94733C13.9821 7.11084 13.7755 7.2091 13.5563 7.22368C13.3326 7.22331 13.1182 7.12961 12.96 6.96313C12.8019 6.79665 12.7129 6.57096 12.7125 6.33553C12.7125 6.14708 12.6414 5.96636 12.5148 5.83311C12.3882 5.69986 12.2165 5.625 12.0375 5.625C11.8585 5.625 11.6868 5.69986 11.5602 5.83311C11.4336 5.96636 11.3625 6.14708 11.3625 6.33553C11.3625 6.57108 11.2736 6.79699 11.1154 6.96355C10.9571 7.13011 10.7425 7.22368 10.5188 7.22368C10.295 7.22368 10.0804 7.13011 9.92213 6.96355C9.7639 6.79699 9.675 6.57108 9.675 6.33553C9.675 6.14708 9.60388 5.96636 9.4773 5.83311C9.35071 5.69986 9.17902 5.625 9 5.625C8.82098 5.625 8.64929 5.69986 8.5227 5.83311C8.39612 5.96636 8.325 6.14708 8.325 6.33553C8.325 6.57108 8.23611 6.79699 8.07787 6.96355C7.91964 7.13011 7.70503 7.22368 7.48125 7.22368C7.25747 7.22368 7.04286 7.13011 6.88463 6.96355C6.7264 6.79699 6.6375 6.57108 6.6375 6.33553C6.6375 6.14708 6.56638 5.96636 6.4398 5.83311C6.31321 5.69986 6.14152 5.625 5.9625 5.625C5.78348 5.625 5.61179 5.69986 5.4852 5.83311C5.35862 5.96636 5.2875 6.14708 5.2875 6.33553C5.28714 6.57096 5.19813 6.79665 5.03998 6.96313C4.88182 7.12961 4.66742 7.22331 4.44375 7.22368C4.22084 7.22074 4.00786 7.12622 3.85022 6.96029C3.69259 6.79436 3.6028 6.57016 3.6 6.33553C3.83912 5.39934 4.20055 4.50262 4.67393 3.67105ZM12.7125 12.1974C12.7125 12.2916 12.6769 12.382 12.6136 12.4486C12.5504 12.5152 12.4645 12.5526 12.375 12.5526H10.35C10.2605 12.5526 10.1746 12.5152 10.1114 12.4486C10.0481 12.382 10.0125 12.2916 10.0125 12.1974V10.0658C10.0125 9.97157 10.0481 9.8812 10.1114 9.81458C10.1746 9.74796 10.2605 9.71053 10.35 9.71053H12.375C12.4645 9.71053 12.5504 9.74796 12.6136 9.81458C12.6769 9.8812 12.7125 9.97157 12.7125 10.0658V12.1974Z" />
                                    </svg>
                                  )}
                                  {isHoveredStoreName ? (
                                    <p
                                      className={classNames(
                                        ` text-Body-OneLine/14/Regular truncatetext `
                                      )}
                                      title={panels.name}
                                    >
                                      فروشگاه {truncateText(panels.name, 11)}
                                    </p>
                                  ) : (
                                    <p
                                      className={classNames(
                                        ` text-Body-OneLine/14/Regular truncatetext`
                                      )}
                                      title={panels.name}
                                    >
                                      فروشگاه {truncateText(panels.name, 11)}
                                    </p>
                                  )}
                                </div>
                              </div>
                            )}
                          </Menu.Item>
                        </div>
                      )
                    )
                  )}
                {userData?.panels?.admin ? (
                  <div
                    className={`py-1 m-1 rounded-lg hover:bg-primary-100 cursor-pointer ${
                      isAdminPath ? "bg-primary-100 text-primary-800" : ""
                    } py-1 m-1 rounded-lg `}
                    onClick={() => navigate("/fa/admin-dashboard")}
                    onContextMenu={(e) => {
                      e.preventDefault();
                      window.open("/fa/admin-dashboard", "_blank");
                    }}
                  >
                    <Menu.Item>
                      {() => (
                        <div
                          className={`py-1 mr-4 hover:text-primary-700 flex items-center justify-start gap-2`}
                        >
                          {<AdminDashboard />}
                          <p
                            className={classNames(
                              `block text-Body-OneLine/14/Regular`
                            )}
                          >
                            پنل ادمین
                          </p>
                        </div>
                      )}
                    </Menu.Item>
                  </div>
                ) : (
                  <></>
                )}
              </>
            )}
          </div>
          <div className="flex flex-col gap-1">
            {
              <div
                className="py-1 m-1 rounded-lg cursor-pointer hover:bg-primary-100"
                onClick={handleDirectToStoreAuth}
                onContextMenu={(e) => {
                  e.preventDefault();
                  window.open("/fa/seller-auth", "_blank");
                }}
              >
                <Menu.Item>
                  {({ active }) => (
                    <div
                      className={`py-1 mr-4 rounded-lg hover:text-primary-700 flex flex-row-reverse items-center justify-end gap-2 `}
                    >
                      <svg
                        className="rotate-180"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="arrow-right-outline">
                          <path
                            id="Vector"
                            d="M17.4184 10.4451C17.4996 10.2324 17.5208 9.99833 17.4794 9.77255C17.438 9.54676 17.3359 9.33938 17.1859 9.17665L12.8999 4.52189C12.8011 4.41074 12.6829 4.32209 12.5521 4.2611C12.4214 4.20011 12.2808 4.16801 12.1385 4.16667C11.9963 4.16533 11.8552 4.19477 11.7235 4.25328C11.5918 4.31179 11.4722 4.3982 11.3716 4.50746C11.271 4.61672 11.1914 4.74665 11.1375 4.88967C11.0836 5.03268 11.0565 5.18591 11.0578 5.34043C11.059 5.49494 11.0886 5.64764 11.1447 5.78962C11.2009 5.93159 11.2825 6.06 11.3848 6.16735L13.8429 8.83685H3.5715C3.28732 8.83685 3.01478 8.95945 2.81383 9.17769C2.61289 9.39592 2.5 9.69191 2.5 10.0005C2.5 10.3092 2.61289 10.6052 2.81383 10.8234C3.01478 11.0416 3.28732 11.1642 3.5715 11.1642H13.8429L11.3859 13.8326C11.2836 13.9399 11.202 14.0683 11.1458 14.2103C11.0896 14.3523 11.0601 14.505 11.0588 14.6595C11.0576 14.814 11.0847 14.9672 11.1386 15.1103C11.1925 15.2533 11.272 15.3832 11.3726 15.4925C11.4732 15.6017 11.5929 15.6881 11.7246 15.7466C11.8562 15.8051 11.9973 15.8346 12.1396 15.8332C12.2819 15.8319 12.4225 15.7998 12.5532 15.7388C12.6839 15.6778 12.8022 15.5892 12.901 15.478L17.187 10.8233C17.2863 10.7149 17.3649 10.5864 17.4184 10.4451Z"
                            fill="#2D67D2"
                          />
                        </g>
                      </svg>
                      <p
                        className={classNames(
                          `block text-Body-OneLine/14/Regular mr-1 text-primary-500`
                        )}
                      >
                        فروشنده شوید
                      </p>
                    </div>
                  )}
                </Menu.Item>
              </div>
            }
            <div
              className="py-1 m-1 rounded-lg hover:bg-red-100 cursor-pointer"
              onClick={logOut}
            >
              <Menu.Item>
                {() => (
                  <div
                    className={`py-1 mr-4 text-red-500 flex items-center justify-start gap-2`}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="arrow-right-to-bracket">
                        <path
                          id="Vector"
                          d="M14.4259 8.82255L14.7795 8.469L14.4259 8.82256C14.4482 8.84483 14.4667 8.87191 14.4804 8.90501C14.5053 8.9654 14.5053 9.0346 14.4804 9.09499C14.466 9.12966 14.4475 9.15616 14.4279 9.17553L14.4259 9.17745L11.4267 12.1767C11.3778 12.2256 11.3145 12.25 11.25 12.25C11.1855 12.25 11.1222 12.2256 11.0733 12.1767C10.9753 12.0787 10.9753 11.9213 11.0733 11.8233L12.7931 10.1036L13.6466 9.25H12.4395H6C5.86172 9.25 5.75 9.13818 5.75 9C5.75 8.86182 5.86172 8.75 6 8.75H12.4395H13.6466L12.7931 7.89645L11.0733 6.1767C10.9753 6.07871 10.9753 5.92129 11.0733 5.8233C11.1713 5.72532 11.3287 5.72532 11.4267 5.8233L14.4259 8.82255ZM5.25 14H7.5C7.63828 14 7.75 14.1118 7.75 14.25C7.75 14.3882 7.63828 14.5 7.5 14.5H5.25C4.28564 14.5 3.5 13.7144 3.5 12.75V5.25C3.5 4.28564 4.28564 3.5 5.25 3.5H7.5C7.63828 3.5 7.75 3.61182 7.75 3.75C7.75 3.88818 7.63828 4 7.5 4H5.25C4.55953 4 4 4.56093 4 5.25V12.75C4 13.4391 4.55953 14 5.25 14Z"
                          fill="#374151"
                          stroke="#F05252"
                        />
                      </g>
                    </svg>
                    <p
                      className={classNames(
                        `block text-Body-OneLine/14/Regular text-red-500`
                      )}
                    >
                      {!localStorage.getItem("old_access_token")
                        ? " خروج از حساب کاربری"
                        : "بازگشت به پنل ادمین"}
                    </p>
                  </div>
                )}
              </Menu.Item>
            </div>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
